export default __webpack_public_path__ + "static/universal-checkout-7ac66a8f535994022633e2d297a2a333.png";